export default "__VITE_ASSET__XGBUAWHd__"